export default function($) {
  var speed = 90,
      touchmoved,
      $wpAdminBar = $('#wpadminbar');

  $('.js-nav-mobile-button').click(function () {
    if($('.js-nav-items').hasClass('nav-items-open')) {
      $('.js-nav-items').slideUp(speed);
      $('.js-nav-items').css({
        'top': '0',
        'height': 'auto',
        'overflow-y': 'visible'
      });
      $('.js-nav-items').removeClass('nav-items-open');
      $('body').removeClass('h-screen');
      $('body').removeClass('overflow-hidden');
      $(this).removeClass('nav-trigger-active');
    } else {
      if ($wpAdminBar.length) {
        var topPos = $('header').outerHeight() + $wpAdminBar.outerHeight();
      } else {
        var topPos = $('header').outerHeight();
      }
      $('.js-nav-items').css({
        'top': topPos+'px',
        'height': 'calc(100vh - '+topPos+'px)',
        'overflow-y': 'auto'
      });
      $('.js-nav-items').slideDown(speed);
      $('.js-nav-items').addClass('nav-items-open');
      $('body').addClass('h-screen');
      $('body').addClass('overflow-hidden');
      $(this).addClass('nav-trigger-active');
    }
  });

  $('.js-nav').find("li.menu-item-has-children").on("click touchend", function (event) {
    if( $(window).width() < 1280 ) {
      //if the one touched is already opened, we want to follow its link
      if(touchmoved != true){
        if($(this).hasClass('menu-item-has-children--active')) {
          window.location = $(this).find('>a').attr("href");
        }
        //then we want to open submenu without following the link
        else {
          event.preventDefault();
          event.stopPropagation();
          $(this).siblings('.menu-item-has-children--active').each(function(i, sibling) {
            $(sibling).removeClass('menu-item-has-children--active').children('.sub-menu').slideUp(speed);
          });
          $(this).children('.sub-menu').slideDown(speed);
          $(this).addClass('menu-item-has-children--active');
        }
      }
    }
  }).on('touchmove', function(e){
    touchmoved = true;
  }).on('touchstart', function(){
    touchmoved = false;
  });

  $(document).click(function(event) {
    if (!$(event.target).closest('.js-nav-mobile-button, .js-nav').length) {
      if ($('.js-nav-mobile-button').hasClass('nav-trigger-active')) {
        $('.js-nav-items').slideUp(speed);
        $('.js-nav-items').css({
          'top': '0',
          'height': 'auto',
          'overflow-y': 'visible'
        });
        $('.js-nav-items').removeClass('nav-items-open');
        $('body').removeClass('h-screen');
        $('body').removeClass('overflow-hidden');
        $('.js-nav-mobile-button').removeClass('nav-trigger-active');
      }
    }
  });

  $(window).resize(function() {
    if( $(window).width() >= 1280 ) {
      $('.js-nav-items').css({
        'display': 'flex',
        'top': '0',
        'height': 'auto',
        'overflow-y': 'visible'
      });
      $('.js-nav-items').removeClass('nav-items-open');
      $('body').removeClass('h-screen');
      $('body').removeClass('overflow-hidden');
      $('.js-nav-mobile-button').removeClass('nav-trigger-active');
    } else {
      $('.js-nav-items').css({
        'display': 'none',
        'top': '0',
        'height': 'auto',
        'overflow-y': 'visible'
      });
      $('.js-nav-items').removeClass('nav-items-active');
      $('.js-nav-mobile-button').removeClass('nav-trigger-active');
    }
  })

  $(window).scroll(function() {
    if ($(this).scrollTop() >= 100) {
      $('.js-backtotop').fadeIn();
    } else {
      $('.js-backtotop').fadeOut();
    }
  });


}
